export default function SectionLabel({ children, inverse = false }) {
  return (
    <p className={`av-section-label${inverse ? " is-inverse" : ""}`}>
      <span aria-hidden="true" />
      {children}
    </p>
  );
}
